import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { MedicationService } from './../../../core/services/medication.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-verify-prescription',
  templateUrl: './verify-prescription.component.html',
  styleUrls: ['./verify-prescription.component.scss']
})
export class VerifyPrescriptionComponent extends BaseComponent implements OnInit {
  verificationToken!: string;
  isLoading = true;
  errorMessage: string | null = null;

  rawPdfUrl = '';
  pdfUrl!: SafeResourceUrl;
  /* downloadLink: string = ''; */

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private medicationService: MedicationService,
    private sanitizer: DomSanitizer,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  /* ngOnInit() {
    this.verificationToken = this.route.snapshot.paramMap.get('token') as string;
    if (this.verificationToken) {
      const sub = this.medicationService.verifyPrescription(this.verificationToken)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          async (response: any) => {
            this.isLoading = false;
            if (response.success) {
              this.showToastMessage('We are generating the original prescription which will be available for download shortly.');
              const details = response.data;
              const pdfBytes = await this.medicationService.createVerifiedPrescriptionPdf(details);
              // Create a blob from the PDF bytes and trigger the download
              const blob = new Blob([pdfBytes], { type: 'application/pdf' });
              const url = window.URL.createObjectURL(blob);
              this.downloadLink = url;
            } else {
              this.errorMessage = response.message;
              this.showToastMessage(response.message);
            }
            sub.unsubscribe();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error.error.message || 'An error occurred during verification.';
            this.showToastMessage(this.errorMessage!);
            sub.unsubscribe();
          }
        );
    } else {
      this.isLoading = false;
      this.errorMessage = 'No verification token was provided. Please scan the QR code on the prescription to verify.';
      this.showToastMessage(this.errorMessage);
    }
  } */

  ngOnInit() {
    this.verificationToken = this.route.snapshot.paramMap.get('token')!;
    if (!this.verificationToken) {
      this.finishWithError('No verification token was provided. Please scan the QR code on the prescription to verify.');
      return;
    }

    const sub = this.medicationService.verifyPrescription(this.verificationToken)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async (response: any) => {
          this.isLoading = false;
          if (!response.success) {
            this.finishWithError(response.message);
            return;
          }

          this.showToastMessage('Generating prescription…');
          const details = response.data;
          const pdfBytes = await this.medicationService
            .createVerifiedPrescriptionPdf(details);

          const blob = new Blob([pdfBytes], { type: 'application/pdf' });
          this.rawPdfUrl = URL.createObjectURL(blob);
          // sanitize it for Angular binding
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.rawPdfUrl);

          sub.unsubscribe();
        },
        err => {
          this.isLoading = false;
          this.finishWithError(err.error?.message || 'An error occurred during verification.');
          sub.unsubscribe();
        }
      );
  }

  private finishWithError(message: string) {
    this.errorMessage = message;
    this.showToastMessage(message);
    this.isLoading = false;
  }
}
